/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Default Value Plugin
 */
import React, { useLayoutEffect } from 'react';
import _ from 'lodash';
import { $generateNodesFromDOM, $generateHtmlFromNodes } from '@lexical/html';
import { $getRoot, $createParagraphNode, $isElementNode, $isDecoratorNode, LexicalNode, $insertNodes, $setSelection } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

interface IProps {
	value?: string | null;
}

const DefaultValuePlugin: React.FC<IProps> = (props) => {
	const { value } = props;

	const [editor] = useLexicalComposerContext();

	useLayoutEffect(() => {
		if (value && editor) {
			editor.update(() => {
				const htmlString = $generateHtmlFromNodes(editor, null);

				if (!_.isEqual(value, htmlString)) {
					const root = $getRoot();
					const parser = new DOMParser();
					const dom = parser.parseFromString(value, 'text/html');
					const nodes = $generateNodesFromDOM(editor, dom);

					let modifiedNodes: LexicalNode[] = [];
					root.clear();
					root.select();

					_.forEach(nodes, (n) => {
						if (n) {
							if (!$isElementNode(n) && !$isDecoratorNode(n)) {
								modifiedNodes = [...modifiedNodes, $createParagraphNode().append(n)];
							} else {
								modifiedNodes = [...modifiedNodes, n];
							}
						}
					});

					$insertNodes(modifiedNodes);
					$setSelection(null);
				}
			});
		}
	}, [value]);

	return null;
};

export default DefaultValuePlugin;
